import { dataInfoCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconInfoCircleSolid = /*#__PURE__*/createIcon(dataInfoCircleSolid)
export default IconInfoCircleSolid
